import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface ICreateLocalServerUserParams {
  username: string;
  displayName: string;
  email: string;
  encryptedPassword: string;
  keyId: string;
  identityPoolName?: string;
  identifier?: string;
}

export interface ICreateLocalServerUserResult {
}

export class CreateLocalServerUserRequest extends Request<ICreateLocalServerUserParams, ICreateLocalServerUserResult> {
  constructor(params: ICreateLocalServerUserParams) {
    super('createLocalServerUser', params);
  }
}
